import { FC } from 'react';

import { SegmentedControl } from '../components/segmented-control/segmented-control';
import styles from './plans.module.css';

type Props = {
    value: '1' | '12'
    onChange: (value: '1' | '12') => void
    disabled?: boolean
};

export const billingPeriodOptions = (showTag?: boolean) => [
    { value: '1', label: 'Monthly' },
    { value: '12', label: <>Annual {showTag && <span className={styles['plans__savings']}>Save More</span>}</> },
];

export const BillingPeriodToggle: FC<Props> = ({ value, disabled, onChange }) => (
    <div className={styles['plans__billing-period']}>
        <SegmentedControl
            name="plan"
            options={billingPeriodOptions(!disabled)}
            value={value}
            disabled={disabled}
            onChange={(evt) => onChange(evt.target.value as '1')}
        />
    </div>
);
